import React from "react";
import { GestionHumanaItem } from "../GestionHumanaItem";
import { Pagination } from "../../../Shared";

export function ListGestionHumana(props) {
  const { onReload, changePage, filteredData, pagination } = props;

  if (!filteredData) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-3 border-[#151C84]/20 border-t-[#151C84] rounded-full animate-spin" />
          <p className="text-sm text-gray-400">Cargando candidatos...</p>
        </div>
      </div>
    );
  }

  if (filteredData.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p className="text-gray-500 font-semibold">No hay formularios en esta categoría</p>
        <p className="text-gray-400 text-sm mt-1">Los candidatos aparecerán aquí cuando estén disponibles.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="space-y-2.5">
        {filteredData.map((formulario) => (
          <GestionHumanaItem
            key={formulario.id}
            formulario={formulario}
            onReload={onReload}
          />
        ))}
      </div>

      {pagination && (
        <Pagination
          page={pagination.page}
          pages={pagination.pages}
          onPage={(p) => changePage(null, { activePage: p })}
          total={pagination.total}
          shown={filteredData.length}
          label="candidatos"
        />
      )}
    </div>
  );
}
